// frontend/src/pages/ActivateAccount.js
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './ActivateAccount.css';

const base = process.env.REACT_APP_API_URL;
if (!base) {
  throw new Error('REACT_APP_API_URL puuttuu. Aseta se Vercelissä/paikallisessa .env:ssä.');
}

const ACTIVATE_URL = new URL('/api/users/activate-account', base).toString();

const ActivateAccount = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [token, setToken] = useState('');
  const [email, setEmail] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [role, setRole] = useState('buyer');
  const [gdprAccepted, setGdprAccepted] = useState(false);

  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isActivated, setIsActivated] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tokenParam = queryParams.get('token');

    if (tokenParam) {
      setToken(tokenParam);
      fetchUserInfo(tokenParam);
    } else {
      setError('Aktivointilinkki ei ole kelvollinen.');
    }
  }, [location.search]);

  const fetchUserInfo = async (token) => {
    try {
      const base = process.env.REACT_APP_API_URL;
      if (!base) throw new Error('REACT_APP_API_URL puuttuu (aseta Vercelissä/.env:ssä).');

      const url = new URL(
        `/api/users/activation-info/${encodeURIComponent(token)}`,
        base
      ).toString();

      const res = await axios.get(url);

      setEmail(res.data.email);
      setCompanyName(res.data.name);
      setRole(res.data.role || 'buyer');
    } catch (err) {
      setError('Käyttäjätietojen hakeminen epäonnistui. Linkki voi olla vanhentunut.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!gdprAccepted) {
      setError('Sinun täytyy hyväksyä palvelun ehdot ja tietosuojaseloste.');
      return;
    }

    if (password.length < 6) {
      setError('Salasanan on oltava vähintään 6 merkkiä pitkä.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Salasanat eivät täsmää.');
      return;
    }

    try {
      const res = await axios.post(ACTIVATE_URL, {
        token,
        password,
        role,
        gdprAccepted,
      });
      
      setMessage(res.data.message || 'Tili aktivoitu onnistuneesti.');
      setIsActivated(true);

      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || 'Tilin aktivointi epäonnistui.');
    }
  };

  return (
    <div className="activate-account-container">
      <h2>Aktivoi tunnuksesi ja aseta salasana</h2>
      {message && <p className="success">{message}</p>}
      {error && <p className="error">{error}</p>}

      {!isActivated && email && (
        <form onSubmit={handleSubmit} className="activate-form">
          <p><strong>Yritys:</strong> {companyName}</p>
          <p><strong>Sähköposti:</strong> {email}</p>

          <label>Salasana:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <label>Vahvista salasana:</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />

          <label>Rooli:</label>
          <select value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="buyer">Ostaja</option>
            <option value="seller">Myyjä</option>
          </select>

          <label className="gdpr-label">
            <input
              type="checkbox"
              checked={gdprAccepted}
              onChange={(e) => setGdprAccepted(e.target.checked)}
              required
            />{' '}
            Hyväksyn <a href="/terms" target="_blank" rel="noopener noreferrer">palvelun ehdot</a> ja{' '}
            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">tietosuojaselosteen</a>
          </label>

          <button type="submit">Aseta salasana ja aktivoi</button>
        </form>
      )}
    </div>
  );
};

export default ActivateAccount;
